import { useEffect, useMemo, useState } from "react";
import {
  APP_STORE_URL,
  EVO_DEEP_LINK,
  GOOGLE_PLAY_URL,
  detectAppPlatform,
  storeUrlForPlatform,
} from "./appLinks";

const FALLBACK_DELAY_MS = 1400;

export default function AppRedirect() {
  const platform = useMemo(() => detectAppPlatform(), []);
  const [didTryOpen, setDidTryOpen] = useState(false);

  useEffect(() => {
    document.title = "Open Evo";

    if (platform === "desktop") return;

    let shouldFallback = true;
    const fallbackUrl = storeUrlForPlatform(platform);
    const fallbackTimer = window.setTimeout(() => {
      if (shouldFallback && document.visibilityState === "visible") {
        window.location.href = fallbackUrl;
      }
    }, FALLBACK_DELAY_MS);

    const cancelFallback = () => {
      shouldFallback = false;
      window.clearTimeout(fallbackTimer);
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") cancelFallback();
    };

    window.addEventListener("pagehide", cancelFallback);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    setDidTryOpen(true);
    window.location.href = EVO_DEEP_LINK;

    return () => {
      window.removeEventListener("pagehide", cancelFallback);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      cancelFallback();
    };
  }, [platform]);

  const copy =
    platform === "desktop"
      ? "Scan or open this page on your phone to launch Evo."
      : didTryOpen
        ? "Opening Evo. If it is not installed, we will send you to the store."
        : "Opening Evo.";

  return (
    <main className="min-h-screen bg-[#f8f7f6] px-5 py-8 text-[#07001a]">
      <section className="mx-auto flex min-h-[calc(100vh-64px)] max-w-[520px] flex-col items-center justify-center text-center">
        <img
          alt="Evo"
          className="mb-8 h-auto w-[118px]"
          src="/evo-logo-full.svg"
        />
        <h1 className="font-['Figtree',sans-serif] text-[40px] font-black leading-[1.1] tracking-[-0.8px]">
          Open Evo
        </h1>
        <p className="mt-4 max-w-[360px] font-['Figtree',sans-serif] text-[16px] font-bold leading-[1.5] text-[#332e3f]">
          {copy}
        </p>
        <a
          className="mt-8 rounded-[24px] bg-[#ff381a] px-6 py-[18px] font-['Figtree',sans-serif] text-[20px] font-black tracking-[-0.4px] text-white no-underline"
          href={EVO_DEEP_LINK}
        >
          Open Evo
        </a>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row">
          <a
            className="rounded-[12px] bg-white px-5 py-3 font-['Figtree',sans-serif] text-[15px] font-black text-[#07001a] no-underline shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]"
            href={APP_STORE_URL}
            rel="noreferrer"
            target="_blank"
          >
            App Store
          </a>
          <a
            className="rounded-[12px] bg-white px-5 py-3 font-['Figtree',sans-serif] text-[15px] font-black text-[#07001a] no-underline shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]"
            href={GOOGLE_PLAY_URL}
            rel="noreferrer"
            target="_blank"
          >
            Google Play
          </a>
        </div>
      </section>
    </main>
  );
}
